export const SET_APP_MESSAGE = 'SET_APP_MESSAGE'
export const CLEAR_APP_MESSAGE = 'CLEAR_APP_MESSAGE'